import { BooleanStore } from 'stores';

const openModalStore = new BooleanStore();

export { openModalStore };
